var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CaseFile',{attrs:{"chart-type":"ClientSubProgramMembership","chart-record-id":_vm.ChartRecordId,"sub-program-id":_vm.SubProgramId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }